import { LittleModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { BillingGroupModelType } from '@teinor/erp/types/company/config/billingGroup'

type ModalCEConfigBillingGroupProps = ModalEditComponentProps & {}

const ModalCEConfigBillingGroup: React.FC<ModalCEConfigBillingGroupProps> = ({ allRowData, userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<BillingGroupModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'is_default',
                    label: t('byDefault', 'Por defecto'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/billingGroup/updateBillingGroup'} translations={{ title: t('editBillingGroup', 'Editar Grupo de facturación'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/billingGroup/createBillingGroup'} translations={{
        title: t('createBillingGroup', 'Crear Grupo de Facturación'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}


export default ModalCEConfigBillingGroup